import { Flex, Text, useBreakpointValue } from "@chakra-ui/react";

export function TableSOr({ children }) {
  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });

  return (
    <Flex direction="column" width="100%">
      <Flex width="100%" borderBottom="1px dashed #c3c3c3" pb={"10px"}>
        <Flex flex={isWideVersion ? "3" : "2"}>
          <Text ml={["4rem", "3.5rem"]} fontSize="text1">
            Itens
          </Text>
        </Flex>
        <Flex flex="1" justifyContent={isWideVersion ? "center" : "flex-start"}>
          <Text fontSize="text1" ml={["5.2rem", "10rem"]}>
            {isWideVersion ? "Quantidade" : "Qtd"}
          </Text>
        </Flex>

        <Flex flex={isWideVersion ? "4" : "3"} justifyContent="flex-end">
          <Text fontSize="text1" mr="1rem">
            Preço
          </Text>
        </Flex>
      </Flex>
      {children}
    </Flex>
  );
}
